<template>
    <section class="comp_settings_chart">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col">
                        <h1 class="part_ui_heading"><span>{{ $t('chart_settings') }}</span></h1>
                    </div>
                </header>
                <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
                    <div class="mod--row mod--row-4">
                        <div class="col col--12" v-for="item in options">
                            <label class="elm_nav_item mod--checkbox">
                                <input type="radio" v-model="type" :value="item" :checked="item == type">
                                <span>{{ $t(item) }}</span>
                                <em class="icon icon--check mod--text-color-c"></em>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'settings-chart-type',
    data() {
        return {
            options: ['daily', 'monthly'],
            type: ''
        }
    },
    mounted() {
        let chart = this.$route.params.chart;
        this.type = localStorage['chart-' + chart + '-type'];
    },
    watch: {
        type: function (val, oldVal) {
            let chart = this.$route.params.chart;
            localStorage['chart-' + chart + '-type'] = val;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/settings-chart-type.vue